<ng-container>
   <samweb-window
      [id]="chatId.uid != null ? chatId.uid : chatId.messageId"
      [type]="windowType"
      [titleBarIcon]="chatIcon"
      [titleBarHeader]="windowTitle$ | async"
      (cancel)="onCancelClicked()"
      showOn="none"
      kendoTooltip
      #closeTooltipDirective="kendoTooltip"
      [tooltipTemplate]="closeDialog"
      tooltipClass="tooltip-chat-window-close-dialog"
   >
      <ng-container>
         <samweb-loading-indicator
            fxFlexFill
            [longRunningContextCategories]="['CHAT_WINDOW']"
            [brickInstanceId]="chatId.uid != null ? chatId.uid : chatId.messageId"
            [showLoadingCircle]="true"
         >
            <fieldset [disabled]="isLoading$ | async" class="fieldset">
               <div *ngIf="!(isLoading$ | async)" fxFlexFill>
                  <ng-container *ngIf="chatDetails; else chatLoadingFailed">
                     <ng-container *ngTemplateOutlet="chat"></ng-container>
                  </ng-container>
               </div>
            </fieldset>
         </samweb-loading-indicator>
      </ng-container>
   </samweb-window>

   <ng-template #chat>
      <div fxLayout="column" fxFlexFill>
         <div class="sam-form-flex-row chat-guest-info">
            <samweb-guest-info [chatGuestInfo$]="chatGuestInfo$"></samweb-guest-info>
            <ng-container *ngTemplateOutlet="actionBar"></ng-container>
         </div>
         <div class="sam-form-flex-row iframe-wrapper">
            <iframe
               [src]="chatUrl"
               width="100%"
               height="100%"
               frameBorder="0"
               (load)="onIframeLoad()"
               #chatIframe
            ></iframe>
         </div>
      </div>
   </ng-template>

   <ng-template #actionBar>
      <span class="action-bar" *ngIf="!chatDetails.isHistoricChat">
         <span
            class="action"
            kendoButton
            kendoTooltip
            look="flat"
            [title]="'samwin.chat_dialog.actions.requeue' | translate"
            (click)="onRequeueClicked()"
            *ngIf="!wasClosedByPeer"
         >
            <fa-icon class="sam-center" [icon]="requeueChatIcon"></fa-icon>
         </span>
         <span
            class="action"
            kendoButton
            kendoTooltip
            look="flat"
            [title]="'samwin.chat_dialog.actions.complete' | translate"
            (click)="onCompleteChatClicked()"
         >
            <fa-icon class="sam-center" [icon]="finishChatIcon"></fa-icon>
         </span>
      </span>
   </ng-template>

   <ng-template #closeDialog>
      <div (samwebOutsideClick)="onCloseDialogCancel()">
         <samweb-chat-confirm-close-dialog
            (complete)="onCloseDialogComplete()"
            (cancel)="onCloseDialogCancel()"
         ></samweb-chat-confirm-close-dialog>
      </div>
   </ng-template>

   <ng-template #chatLoadingFailed>
      <div fxLayout="column" fxFlexFill>
         <div class="sam-form-row sam-center" fxFlexFill style="overflow: hidden">
            <fa-icon [icon]="warningIcon" size="5x"></fa-icon>
            <div style="font-weight: bold; margin-top: 1em; margin-bottom: 2em">
               {{ 'samwin.chat_dialog.error_handling.chat_loading_failed' | translate }}
            </div>
         </div>
      </div>
   </ng-template>
</ng-container>
